export const blockIconsMapsMedicalServices = (
	<span className='material-symbols-outlined'>medical_services</span>
);
